import React from 'react'
import { fireAnalyticsEvent } from '~analyticsUtils'
import Image from 'next/image'
import Link from 'next/link'
import { SocialMediaItemProps } from '~types'
import styles from './SocialMediaRow.module.scss'
import { useRouter } from 'next/router'
import { NEXT_IMAGE_QUALITY } from '~constants'

const SocialMediaItem = ({ icon, platformName, url }: SocialMediaItemProps) => {
  const { asPath } = useRouter()
  const linkModule = 'social_media'

  return icon?.url ? (
    <div className={styles['social-item']}>
      <Link
        href={url}
        target={'_blank'}
        onClick={() => {
          fireAnalyticsEvent(url, asPath, {
            clickTracking: `${linkModule}:${platformName}`,
            linkLocation: 'footer',
            linkModule: linkModule
          })
        }}
      >
        <Image width={36} height={36} sizes='100vw' alt={platformName} src={icon.url} quality={NEXT_IMAGE_QUALITY} />
      </Link>
    </div>
  ) : null
}

export default SocialMediaItem
